import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuType } from '../utils/dto/response';
import { decryptText, hasAccessToPath } from '../utils/utils';

type PermissionContextType = {
    permissions: MenuType | null;
    checkPermission: (permissionSlug: string) => boolean
    isAccessToViewDecryptedData: (permissionSlugs: Array<string>) => boolean
};

const PermissionContext = createContext<PermissionContextType>({
    permissions: null,
    checkPermission: () => false,
    isAccessToViewDecryptedData: () => false
});

export const PermissionProvider = ({ children }: { children: React.ReactNode }) => {
    const permissions = JSON.parse(decryptText(localStorage.getItem('roles_permissions')) || '{}').menus
    const location = useLocation();

    const currentPermission = useMemo(() => hasAccessToPath(permissions, location.pathname),
        [permissions, location.pathname]
    );

    const isAccessToViewDecryptedData = (permissionSlugs: Array<string>) => {
        if (currentPermission && currentPermission.permissions && currentPermission.permissions.length > 0) {
            return currentPermission.permissions.some((permission: any) => permissionSlugs.includes(permission.slug))
        }
        return false
    }

    const checkPermission = (permissionSlug: string): boolean => {
        if (currentPermission && currentPermission.permissions && currentPermission.permissions.length > 0) {
            return currentPermission.permissions.some((perm: any) => perm === permissionSlug);
        }
        return false;
    };

    const value = useMemo(
        () => ({
            permissions: currentPermission,
            checkPermission: checkPermission,
            isAccessToViewDecryptedData: isAccessToViewDecryptedData
        }),
        [currentPermission]
    );

    // if (!currentPermission && location.pathname !== '/') {
    //     return <ErrorLayoutForAdmin />
    //         ;
    // }

    return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}

export const usePermissions = (): PermissionContextType => useContext(PermissionContext)